import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {login} from 'apa/actions';
import {Modal, ModalHeader, ModalBody, Form, Button, Col, Container, Input, ListGroup, Progress, Row, FormGroup, CustomInput} from 'reactstrap'
import {Presentation} from 'apa/containers/Presentation';
import Dialog from 'apa/containers/Dialog';
import TextArea from 'apa/components/TextArea';
import Date from 'apa/components/Date';
import Loading from 'apa/components/Loading';

const Answer = (props) => {
    const {answer} = props
    const correct = answer.selected === answer.correct
    const highlight = (correct && answer.selected) || (!correct)

    const getClass = (correct, highlight) => {
        if(highlight) {
            return correct ? 'alert-success' : 'alert-danger'
        }
        return ''
    }
    const className = getClass(correct, highlight)
    return <div className={`alert ${className} answer-alert`} role='alert'>
        <div className={'answer-checkmark'}>
            {answer.selected &&
            <i className='fas fa-check'> </i>
            }
        </div>
        <div className={'answer-text'}>
            {answer.text}
        </div>
    </div>
}


export const CodeDetails = (props) => {
    const {codeDetails}= props;
    const hideID = props.hideID;
    return (
        <Fragment>
            {!hideID &&
            <Fragment>
                <p>
                    Code: {codeDetails.code}
                </p>
                <p>
                    ID: {codeDetails.id_txt}
                </p>
            </Fragment>
            }
            <h2>Auswertung</h2>
            {
                codeDetails.status === 3 &&
                    <p>Glückwunsch, ihr Teilnahmezertifikat können sie <a href={codeDetails.certificate}>hier</a> runterladen.</p>
            }
            {
                codeDetails.results &&
                codeDetails.results.results &&
                codeDetails.results.results.map(
                    (result, index) =>
                        <div key={`question_key_${index}`} className={'question-container'}>
                            <p className={'question-text'}>
                                {index + 1}. {result.text}
                            </p>
                            {result.answers.map(
                                (answer, index) => <Answer key={`answer_key_${index}`} answer={answer} />
                            )}
                            {
                                result.alternative &&
                                <p className={'text-muted question-explanation'}>{result.alternative}</p>
                            }
                        </div>
                )
            }
        </Fragment>

    )
}

const overview = {
    customer: '',
    name: '',
    description: '',
    start_at: '',
    end_at: '',
    access_codes: [],
    data: [],
}


@connect(
    state => ({
        errors: state.apa.errors,
        isAuthenticated: state.apa.isAuthenticated,
        token: state.apa.token
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class TrainingOverview extends Component {

    state = {
        current: 0,
        overview: overview,
        codeDetails: null,
        isReleaseModalOpen: false,
        isSendModalOpen: false,
        newPresentationFile: '',
        newPresentationModal: false,
        isUploading: false,
        newCodes: 1
    }

    componentDidMount() {
        const uuid = this.props.match.params.uuid;
        const headers = {
            'Content-Type': 'application/json',
        };
        fetch(
            `https://apabackend.quixtest.de/api/customers/training/${uuid}/`,
            {headers}
        ).then(
            res => res.json()
        ).then(
            res => this.setState(
                {overview: res}
            )
        )
    }


    render() {
        const overview = this.state.overview
        const slides = overview.presentation_slides || [];

        const updateName = (value, code, name) => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'code': code.code,
                    'name': value
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/update_code/`,
                {headers, method: 'POST', body}
            )
        }
        const updateEmail = (value, code, name) => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'code': code.code,
                    'email': value
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/update_code/`,
                {headers, method: 'POST', body}
            )
        }
        const updateFunction = (value, code, name) => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'code': code.code,
                    'function': value
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/update_code/`,
                {headers, method: 'POST', body}
            )
        }
        const updatePersonalNum = (value, code, name) => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'code': code.code,
                    'phone_num': value
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/update_code/`,
                {headers, method: 'POST', body}
            )
        }
        const releaseTraining = () => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json'
            };
            const body = JSON.stringify(
                {
                    'uuid': uuid,
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/release/`,
                {headers, method: 'POST', body}
            ).then(
                res => res.json()
            ).then(
                res => this.setState({overview: res})
            )
        }

        const toggleReleaseModal = () => {
            this.setState({
                isReleaseModalOpen: !this.state.isReleaseModalOpen
            })
        }

        const toggleSendModal = () => {
            this.setState({
                isSendModalOpen: !this.state.isSendModalOpen
            })
        }

        const sendInvitation = () => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ${this.props.token}`
            };
            const body = JSON.stringify(
                {
                    'uuid': uuid,
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/send_invitation/`,
                {headers, method: 'POST', body}
            ).then(
                res => res.json()
            ).then(
                res => this.setState({overview: res})
            )
        }

        const toggleCodeDetails = (code) => {
            this.setState({
                codeDetails: this.state.codeDetails ? null : code
            })
        }

        const {codeDetails} = this.state || {}

        const displayResultsCol = (results) => {
            if(Object.prototype.hasOwnProperty.call(results, 'correct')) {
                return <span>
                    {results.correct} / {results.max} ({Math.round(results.percentage)} %)
                </span>
            }
            return null;
        }

        const updateTraining = (event) => {
            const fieldName = event.target.name
            const fieldValue = event.target.value

            const overview = {...this.state.overview, [fieldName]: fieldValue}

            this.setState({
                overview: overview
            })
        }

        const saveTraining = () => {
            const uuid = this.props.match.params.uuid;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ${this.props.token}`
            };
            const overview = {...this.state.overview}
            delete overview.codes_file
            delete overview.presentation
            const body = JSON.stringify(
                overview
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/`,
                {headers, method: 'PATCH', body}
            ).then(
                res => res.json()
            ).then(
                res => this.setState({overview: res})
            )
        }

        const addCodes = () => {
            const uuid = this.props.match.params.uuid;
            const number_of_codes = this.state.newCodes;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ${this.props.token}`
            };
            const body = JSON.stringify(
                {
                    'uuid': uuid,
                    'number_of_codes': number_of_codes
                }
            )
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/add_code/`,
                {headers, method: 'POST', body}
            ).then(
                res => res.json()
            ).then(
                () => window.location.reload()
            )
        };

        const toggleUploadConfirmation = () => {
            this.setState({newPresentationModal: !this.state.newPresentationModal})
        }

        const confirmUpload = () => {
            const uuid = this.props.match.params.uuid;
            this.setState({isUploading:true})
            const headers = {
                'Authorization': `Token ${this.props.token}`
            };
            const body = new FormData();
            body.append('presentation', this.state.newPresentationFile);
            fetch(
                `https://apabackend.quixtest.de/api/customers/training/${uuid}/`,
                {headers, method: 'PATCH', body}
            ).then(res => res.json())
                .then(
                    () => window.location.reload()
                )

        }

        const handleFileChange = ({target: {files}}) => {
            const cancel = !files.length;
            if (cancel) return;

            const file = files[0];
            if (file.name.endsWith('.pptx')) {
                this.setState({ newPresentationFile: file, invalidFile: false });
                toggleUploadConfirmation()
            } else {
                this.setState({ newPresentationFile: '', invalidFile: true });

            }
        }

        const can_edit = this.props.isAuthenticated;

        return (
            <Container>
                <h1>{overview.name}</h1>
                <h2>{overview.customer_name}</h2>
                <p>
                    <Date date={overview.start_at} /> bis <Date date={overview.end_at} />
                </p>
                <h3>
                    Vorschau der Präsentation
                </h3>
                <Presentation  items={slides} />
                <br/>
                {
                    can_edit &&
                    <FormGroup>
                        <CustomInput
                            type="file"
                            id="exampleCustomFileBrowser"
                            name="customFile"
                            label={this.state.newPresentationFile || 'Schulungs .pptx ersetzen'}
                            onChange={handleFileChange}
                            invalid={this.state.invalidFile} />
                        <Dialog
                            isOpen={this.state.newPresentationModal}
                            toggle={toggleUploadConfirmation}
                            confirm={confirmUpload}
                            title={'Schulungspersentation ersetzen'}
                        >
                            Das kann einige Augenblicke dauern.
                            {
                                this.state.isUploading &&
                                <Loading />
                            }
                        </Dialog>
                    </FormGroup>
                }
                <h3>
                    Beschreibung
                </h3>
                <TextArea disabled={!can_edit} onChange={updateTraining} onBlur={saveTraining} name='description' value={overview.description} />
                <br/>
                <h3>
                    Übersicht der Themen
                </h3>
                <ListGroup>
                    {
                        overview.data.map(
                            question => <Row className="mt-1" key={`question_selection_${question.id}`}>
                                <Col>
                                    <strong>{question.label}</strong>
                                </Col>
                                <Col>
                                    <Input disabled style={{backgroundColor: "#DFDFDF"}} placeholder="Fragen" type="number" min={1} defaultValue={question.number}/>
                                </Col>
                            </Row>
                        )
                    }
                </ListGroup>
                <div>
                    <h3>
                        Statistiken
                    </h3>
                    <h4>
                        Übersicht der Registrierungen
                    </h4>
                    <Progress multi>
                        <Progress bar color="success" value={overview.registered}>
                            Registriert ({Math.round(overview.registered)} %)
                        </Progress>
                        <Progress bar color="info" value={overview.not_used}>
                            Offen ({Math.round(overview.not_used)} %)
                        </Progress>
                    </Progress>
                    <br/>
                    <h4>
                        Ergebnisse der Wissenskontrolle
                    </h4>
                    <Progress multi>
                        <Progress bar color="success" value={overview.success}>
                            Bestanden ({Math.round(overview.success)} %)
                        </Progress>
                        <Progress bar color="info" value={overview.no}>
                            Offen ({Math.round(overview.no)} %)
                        </Progress>
                        <Progress bar color="warning" value={overview.repeat}>
                            Wiederholung ({Math.round(overview.repeat)} %)
                        </Progress>
                        <Progress bar color="danger" value={overview.fail}>
                            Durchgefallen ({Math.round(overview.fail)} %)
                        </Progress>
                    </Progress>
                    <br/>
                    <h3>
                        Übersicht der Zugangscodes
                    </h3>
                    <p>
                        Hier müssen die Zugangscodes zu den Mitarbeitern zugeordnet werden.
                    </p>
                    {
                        can_edit &&
                        <FormGroup row>
                            <Col sm={12}>
                                <Input style={{width: '5em', 'float': 'left'}} type='number' min={1} max={10} value={this.state.newCodes} onChange={
                                    e => this.setState({newCodes: e.target.value})
                                } />
                                <Button onClick={addCodes} color={'primary'}>
                                    <i className='fa fa-plus'> </i> Zugangscodes hinzufügen
                                </Button>
                            </Col>
                        </FormGroup>
                    }
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>
                                Zugangscode
                            </th>
                            {/* <th colSpan={2}>
                                Eindeutige Bezeichnung (Name, Personalnummer o.ä.)
                            </th> */}
                            { !can_edit &&
                            <>
                                <th>
                                    Name
                                </th>
                                <th>
                                    E-Mail
                                </th>
                                <th>
                                    Funktion  
                                </th>
                                <th>
                                    Personalnummer
                                </th>
                            </>
                            }
                            <th>
                                Benutzt
                            </th>
                            <th>
                                Bestanden
                            </th>
                            <th>
                                Punkte
                            </th>
                            <th>

                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            overview.access_codes.map(
                                (code, idx) => (
                                    <tr key={`code_${idx}`}>
                                        <td>
                                            {code.code}
                                        </td>
                                        {/* <td colSpan={2}>
                                            <Input defaultValue={code.id_txt} onBlur={
                                                (e) => updateCode(e.target.value, code)
                                            } />
                                        </td> */}
                                         { !can_edit &&
                                            <>
                                                <td>
                                                    <Input defaultValue={code.additionalinformation.name} onBlur={
                                                    (e) => updateName(e.target.value, code, "name")
                                                    } />
                                                </td>
                                                <td>
                                                    <Input defaultValue={code.additionalinformation.email} onBlur={
                                                    (e) => updateEmail(e.target.value, code, "email")
                                                    } />
                                                </td>
                                                <td>
                                                    <Input defaultValue={code.additionalinformation.function} onBlur={
                                                    (e) => updateFunction(e.target.value, code, "function")
                                                    } />    
                                                </td>
                                                <td>
                                                    <Input defaultValue={code.additionalinformation.phone_num} onBlur={
                                                    (e) => updatePersonalNum(e.target.value, code, "phone_num")
                                                    } />    
                                                </td>
                                            </>
                                          }
                                        <td>
                                            {
                                                !code.user &&
                                                <i className={'fa fa-times'}> </i>
                                            }
                                            {
                                                code.user &&
                                                <i className={'fa fa-check'}> </i>
                                            }
                                        </td>
                                        <td>
                                            {
                                                code.status < 2 &&
                                                <i className={'fa fa-times'}> </i>
                                            }
                                            {
                                                code.status > 1 &&
                                                <i className={'fa fa-check'}> </i>
                                            }
                                        </td>
                                        <td>
                                            {
                                                displayResultsCol(code.results)
                                            }
                                        </td>
                                        <td>
                                            <Button color='primary' size={'sm'} onClick={() => toggleCodeDetails(code)}>Details</Button>
                                        </td>
                                    </tr>
                                )
                            )
                        }
                        </tbody>
                    </table>
                    <Modal isOpen={codeDetails} toggle={toggleCodeDetails} size='lg'>
                        <ModalHeader toggle={toggleCodeDetails}>
                            Details
                        </ModalHeader>
                        <ModalBody>
                            {
                                codeDetails &&
                                <CodeDetails codeDetails={codeDetails} />
                            }
                        </ModalBody>
                    </Modal>
                    <h3>
                        Aktionen
                    </h3>
                    {
                        !overview.codes_file &&
                        <p>
                            <a href='#' className='btn btn-primary' onClick={e => {
                                e.preventDefault();
                                toggleReleaseModal();
                            }}>
                                Zugangcodes freigeben
                            </a>
                            <Dialog isOpen={this.state.isReleaseModalOpen}
                                    toggle={toggleReleaseModal}
                                    title={'Freigabe bestätigen'}
                                    confirm={releaseTraining}
                            />
                        </p>
                    }
                    {
                        overview.codes_file &&
                        <p>
                            <a href={overview.codes_file} target='_blank' referrerPolicy='no-referrer' className='btn btn-success'>
                                <i className='fa fa-download'> </i>
                                &nbsp;
                                Zugangscodes (PDF)
                            </a>
                            <a href='#' className='btn btn-primary' onClick={e => {
                                e.preventDefault();
                                releaseTraining();
                            }}>
                                <i className='fa fa-sync'> </i>
                            </a>
                        </p>
                    }
                    {
                        this.props.isAuthenticated &&
                        <p>
                            <Button color='primary' onClick={toggleSendModal}>
                                <i className='fa fa-envelope'> </i>
                                &nbsp;
                                Einladung an Verantwortlichen senden
                            </Button>
                            <Dialog isOpen={this.state.isSendModalOpen}
                                    toggle={toggleSendModal}
                                    title={'Einladung an Verwantworlichen bestätigen'}
                                    confirm={() => {
                                        sendInvitation();
                                        toggleSendModal();
                                    }}
                            />
                        </p>
                    }
                </div>
            </Container>
        )
    }
}

